import "@deere/ux.uxframe-core/dist/css/uxframe-2019.3.0.min.css";
import PdcHeader from './shared/PdcHeader';
import { Main } from "./shared/Main";
import { BrowserRouter } from 'react-router-dom';
import PdcFooter from "./shared/PdcFooter";
import ScrollTop from "./shared/ScrollTop";

export default function App() {
  return (
    <BrowserRouter>
        <ScrollTop/>
        <PdcHeader/>
        <Main/>
        <PdcFooter/>
    </BrowserRouter>
  );
}


